import TablaConciliacion from "../../../TablaConciliacion";

function TablaRutaAlSur() {
  return <TablaConciliacion nombreUseCase="RUTAALSUR" titulo="RUTA AL SUR" />;
}

export default TablaRutaAlSur;
